import * as React from 'react';
import { Header4, Paragraph2 } from '@cian/ui-kit/typography';

import { PROMO_ICON } from '../../constants/promoIcon';
import { EPromoType, IPromo } from '../../types/newbuilding/promos';
import { BankIcon } from './components/BankIcon';
import * as styles from './styles.css';

interface IPromoItemProps {
  promo: IPromo;
  onClick(): void;
  onHover(): void;
}

export function PromoItem({ promo, onClick, onHover }: IPromoItemProps) {
  const { bank, promoType, name, subtitle } = promo;
  const icon = PROMO_ICON.get(promoType);

  return (
    <div className={styles['container']} onClick={onClick} onMouseEnter={onHover}>
      <div className={styles['icon']}>
        {promoType === EPromoType.Bank ? <BankIcon bank={bank} /> : <img src={icon} />}
      </div>
      <div>
        <div className={styles['title']}>
          <Header4 as="h4">{name}</Header4>
        </div>
        {subtitle && <Paragraph2 color="gray60_100">{subtitle}</Paragraph2>}
      </div>
    </div>
  );
}
